import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "radiobutton-off",
  "use": "radiobutton-off-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"radiobutton-off\">\n<rect x=\"2\" y=\"2\" width=\"12\" height=\"12\" rx=\"6\" fill=\"white\" stroke=\"#92929D\" stroke-width=\"1.25\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol